/* Core & libraries */
import * as React from "react";
import {useEffect} from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import CompanyDeletedContent from "../../components/companyDeletedContent";

/* Styles */
import styles from "./styles";

const CompanyDeleted = () => {

  return (
    <div>
      <CompanyDeletedContent />
    </div>
  )
}

export default CompanyDeleted;